import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material';


import GroupIcon from '@mui/icons-material/Group';
import SecurityIcon from '@mui/icons-material/Security';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import FactoryIcon from '@mui/icons-material/Factory';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import OutputIcon from '@mui/icons-material/Output';
import TimerIcon from '@mui/icons-material/Timer';
import { useNavigate } from 'react-router-dom';
import { APP_DATA } from '../data';
import { getSession } from '../services/apis';
import { getUsuarioFromSession, puedeVerOpcionAjustes } from '../utils/permisos';

const opcionesAjustes = [
    {
        nombre: 'Usuarios',
        descripcion: `Gestion de usuarios de ${APP_DATA.empresaNombre}`,
        url: '/usuarios',
        icon: 'GroupIcon',
        permiso: 'usuarios',
    },
    {
        nombre: 'Roles',
        descripcion: 'Gestion de roles',
        url: '/roles-y-departamentos',
        icon: 'SecurityIcon',
        permiso: 'roles',
    },
    {
        nombre: 'Maestros Business Central',
        descripcion: 'Gestion de maestros sincronizados con Business Central',
        url: '/confecciones',
        icon: 'BusinessCenterIcon',
        permiso: 'maestrosBusinessCentral',
    },
    {
        nombre: 'Almacenes',
        descripcion: `Gestion de almacenes de ${APP_DATA.empresaNombre}`,
        url: '/centros',
        icon: 'FactoryIcon',
        permiso: 'maestrosAlmacen',
    },
    {
        nombre: 'Tipos de maquinas',
        descripcion: 'Gestion de tipos de maquinas',
        url: '/tipos-maquinas',
        icon: 'PrecisionManufacturingIcon',
        permiso: 'maestrosGlobales',
    },
    {
        nombre: 'Salidas produccion',
        descripcion: 'Gestion de salidas de produccion por almacen y tipo',
        url: '/salidas-produccion',
        icon: 'OutputIcon',
        permiso: 'maestrosAlmacen',
    },
    {
        nombre: 'Parametros tiempo',
        descripcion: 'Gestion de tiempos por salida, confeccion, variedad y peso',
        url: '/parametros-tiempo',
        icon: 'TimerIcon',
        permiso: 'maestrosGlobales',
    },
];


export const Ajustes = () => {

    const Navigate = useNavigate()
    const [usuarioSesion, setUsuarioSesion] = useState(null)

    useEffect(() => {
        const cargarSesion = async () => {
            try {
                const session = await getSession()
                setUsuarioSesion(getUsuarioFromSession(session))
            } catch (error) {
                console.error('Error al cargar permisos de ajustes:', error)
                setUsuarioSesion(null)
            }
        }

        cargarSesion()
    }, [])

    const icons = {
        GroupIcon: <GroupIcon color='primary' sx={{ fontSize: 55 }} />,
        SecurityIcon: <SecurityIcon color='primary' sx={{ fontSize: 55 }} />,
        BusinessCenterIcon: <BusinessCenterIcon color='primary' sx={{ fontSize: 55 }} />,
        FactoryIcon: <FactoryIcon color='primary' sx={{ fontSize: 55 }} />,
        PrecisionManufacturingIcon: <PrecisionManufacturingIcon color='primary' sx={{ fontSize: 55 }} />,
        OutputIcon: <OutputIcon color='primary' sx={{ fontSize: 55 }} />,
        TimerIcon: <TimerIcon color='primary' sx={{ fontSize: 55 }} />,
    }


    return (
        <Grid
            container
            direction="column"
            size={{ xs: 12 }}
            sx={{
                justifyContent: "start",
                alignItems: "start",
            }}
        >
            <Grid
                container
                direction="row"
                size={{ xs: 12 }}
                sx={{
                    justifyContent: "center",
                    alignItems: "center",
                }}
                className='fade-in ajustes-compact'
            >

                <Grid
                    container
                    direction="row"
                    size={{ xs: 10 }}
                    sx={{
                        justifyContent: "center",
                        alignItems: "center",
                        mt: 4,
                    }}
                    spacing={2}
                >
                    {opcionesAjustes
                        .filter((info) => puedeVerOpcionAjustes(usuarioSesion, info.permiso))
                        .map((info, index) => (
                        <Grid
                            key={info.url}
                            container
                            direction="column"
                            size={{ xs: 12, md: 12, lg: 4 }}
                            sx={{
                                justifyContent: "center",
                                alignItems: "start",
                                p: 2,
                                ':hover': {
                                    backgroundColor: '#ffffff',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease-in-out',
                                },
                                transition: 'all 0.3s ease-in-out',

                            }}
                            className='card-main '
                            onClick={() => Navigate(info.url)}
                        >
                            <Grid
                                container
                                size={{ xs: 12 }}
                                sx={{
                                    justifyContent: "start",
                                    alignItems: "center",
                                }}
                            >
                                {icons[info.icon]}
                            </Grid>

                            <Typography variant='h4'>
                                {info.nombre}
                            </Typography>

                            <Typography variant='subtitle1'>
                                {info.descripcion}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>

            </Grid>

        </Grid >
    )
}
